import { getProduct } from "../services/Rest.jsx";
import useFetch from "./useFetch.jsx";

const useProduct = (productId) => {
  return useFetch(getProduct, true, productId);
};

export default useProduct;
